import type {ReactElement} from 'react';
import {useState} from 'react';
import {useEffect} from 'react';
import React from 'react';
import type {ProductsResponse} from '@Libraries/poster-download-library';
import {getProductsForPoster} from '@Libraries/poster-download-library';
import {DownloadPanelProvider} from '@Components/download-panel/download-panel.context';
import {DownloadPanelContentManager} from '@Components/download-panel/components/download-panel-content-manager/download-panel-content-manager';
import type {PosterLoadObject} from '@PosterWhiteboard/poster/poster.types';
import {useGetWebDownloadPosterTypes} from '@Hooks/download-dialog/useGetWebDownloadPosterTypes';
import type {DownloadPanelDefaultOptions} from '@Components/download-panel/download-panel.types';

export interface DownloadPanelContent {
  id: string;
  className?: string;
  posterObject: PosterLoadObject;
  isOpenedInModal?: boolean;
  isOpenedInEditor?: boolean;
  isOpenedInPrintShop?: boolean;
  defaultOptions?: DownloadPanelDefaultOptions;
  posterVersionId?: string;
  showOutdatedPosterInfoBox?: boolean;
}

export function DownloadPanelContent({className = '', isOpenedInPrintShop = false, isOpenedInEditor = true, ...props}: DownloadPanelContent): ReactElement {
  const [productsData, setProductsData] = useState<ProductsResponse>();
  useGetWebDownloadPosterTypes();

  const getDataAndSetProducts = async (): Promise<void> => {
    if (!props.posterObject.hashedID) {
      return;
    }
    try {
      const productsPromise = getProductsForPoster(props.posterObject);
      const products = await productsPromise;
      setProductsData(products);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect((): void => {
    void getDataAndSetProducts();
  }, [props.posterObject.hashedID]);

  return (
    <DownloadPanelProvider
      posterVersionId={props.posterVersionId}
      showOutdatedPosterInfoBox={props.showOutdatedPosterInfoBox}
      defaultOptions={props.defaultOptions}
      key={props.posterObject.hashedID}
      productsResponse={productsData}
      posterObject={props.posterObject}
    >
      <DownloadPanelContentManager
        isOpenedInPrintShop={isOpenedInPrintShop}
        isOpenedInEditor={isOpenedInEditor}
        isOpenedInModal={props.isOpenedInModal}
        id={props.id}
        className={className}
      />
    </DownloadPanelProvider>
  );
}
